import { Injectable } from '@angular/core';
import { environment } from "../environments/enviroment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, map, of, shareReplay } from 'rxjs';
import { HomeBannersResponse } from '../shared/models/home-banner.model';


@Injectable({
  providedIn: 'root'
})
export class Listado {

  constructor( private http: HttpClient ) { }

  private baseUrl: string = environment.apiBaseUrl;
  private shortsAvailabilityRequests = new Map<string, Observable<boolean>>();

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }

  /* ////////////////// */
  /* //FUNCIONES HOME// */
  /* ////////////////// */

  getSliderHome(id_usuario:string){
    // const url = `${ this.baseUrl }/contenidoHome/sliderHome`;
    const url = `${ this.baseUrl }/contenidoHome/sliderHome/${id_usuario}`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }

  getProximosContenidos() {
    const url = `${this.baseUrl}/contenidoHome/proximosContenidos`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get(url, { headers });
  }

  getAvanceUsuario(id_usuario:string){
    const url = `${ this.baseUrl }/contenidoHome/avanceUsuario/${ id_usuario }`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }

  getShortsNuevos(idUsuario: string) {
    const url = `${this.baseUrl}/contenidoHome/shortsNuevos/${idUsuario}`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    return this.http.get<any>(url, { headers });
  }

  getBannersDisponibles(idUsuario: string): Observable<HomeBannersResponse> {
    const normalizedUserId = (idUsuario || '').trim();
    const url = normalizedUserId
      ? `${this.baseUrl}/banners/disponibles/${normalizedUserId}`
      : `${this.baseUrl}/banners/disponibles`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });

    return this.http.get<HomeBannersResponse>(url, { headers });
  }

  getPopularSemana(id_usuario:string){
    const url = `${ this.baseUrl }/contenidoHome/popularSemana/${ id_usuario }`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }

  getProximosLives(idUsuario:string){
    const url = `${ this.baseUrl }/contenidoHome/proximosLives/${ idUsuario }`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }

  getListasReproduccion(){
    const url = `${ this.baseUrl }/recuperaListasReproduccion`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }

  getSugerenciasUsuario(id_usuario:string){
    const url = `${ this.baseUrl }/contenidoHome/sugerenciasUsuario/${ id_usuario }`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }

  getProximoContenido(){
    const url = `${ this.baseUrl }/contenidoHome/proximosContenidos`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }

  /* /////////////////////////////// */
  /* //FUNCIONES LISTADO CONTENIDO// */
  /* /////////////////////////////// */

  getListadoContenido( tipoContenido:string, id_usuario:string ){
    //masterclasses
    //podcasts
    //retransmisiones
    //capsulas
    //shorts
    const url = `${ this.baseUrl }/contenido/${ tipoContenido }/${ id_usuario }`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    ////console.log(url, {headers});
    
    return this.http.get( url, { headers } );
  }

  getCasosClinicos(){
    const url = `${ this.baseUrl }/casos-clinicos`;
    return this.http.get( url, { headers: this.getAuthHeaders() } );
  }

  hasAvailableShorts(idUsuario: string): Observable<boolean> {
    const normalizedUserId = (idUsuario || '').trim();

    if (!normalizedUserId) {
      return of(false);
    }

    const cachedRequest = this.shortsAvailabilityRequests.get(normalizedUserId);
    if (cachedRequest) {
      return cachedRequest;
    }

    const request = this.getListadoContenido('shorts', normalizedUserId).pipe(
      map((response: any) => {
        const shorts = Array.isArray(response?.data) ? response.data : [];
        return shorts.some((short: any) => this.isUsableShort(short));
      }),
      catchError(() => of(false)),
      shareReplay({ bufferSize: 1, refCount: false })
    );

    this.shortsAvailabilityRequests.set(normalizedUserId, request);
    return request;
  }

  isUsableShort(short: any): boolean {
    const video = short?.video;
    const hasVideo = typeof video === 'string'
      ? video.trim().length > 0
      : Boolean(video?.id || video?.url);

    return Boolean(short?._id && short?.imagen_portada?.url && hasVideo);
  }

  cargarShorts(idUsuario: string, excludeIds: string[], limit: number = 5) {
    const url = `${this.baseUrl}/contenido/shorts/cargar/${idUsuario}`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
    const normalizedLimit = Number.isFinite(limit) ? Math.trunc(limit) : 5;
    const body = {
      exclude_ids: Array.from(new Set(excludeIds.filter(Boolean))),
      limit: Math.min(Math.max(normalizedLimit, 1), 5)
    };

    return this.http.post<any>(url, body, { headers });
  }

  getListadoAreas(){
    const url = `${ this.baseUrl }/areas`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }


  /* //////////////////////////////////// */
  /* //FUNCIONES LISTADO MI APRENDIZAJE// */
  /* //////////////////////////////////// */


  getListadoInscripcionesActivas( id_usuario:string ){
    const url = `${ this.baseUrl }/mi-aprendizaje/activas/${id_usuario}`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }

  getListadoCompletados( id_usuario:string ){
    const url = `${ this.baseUrl }/mi-aprendizaje/completados/${id_usuario}`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }
  
  getListadoMiActividad( id_usuario:string ){
    const url = `${ this.baseUrl }/mi-aprendizaje/mi-actividad/${id_usuario}`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }

  getListadoFavoritos( id_usuario:string ){
    const url = `${ this.baseUrl }/mi-aprendizaje/favoritos/${id_usuario}`;
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.get( url, { headers } );
  }

  getResultadosBusqueda( busqueda:any, idUsuario:string ){
    const url = `${ this.baseUrl }/busqueda/${ idUsuario }`;
    const body = {term: busqueda};
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    })
    return this.http.post<any>( url, body, { headers } );
  }



}
